import { combineReducers } from "redux";
import general from './general'
import persist from './persist'
import reducer from './reducer'
export default combineReducers({
    general,
    persist,
    reducer
})